export default __webpack_public_path__ + "5d06b19560dcfe99531801dfa95dae4f.png";